module.exports = __webpack_public_path__ + "img/bg_comm_png.26694580.png";